import cjsModule from './cjs/index.js';
/*eslint no-empty-pattern: "warn"*/
export const { __esModule, arrayEquality, deepEquality, objectEquality } =
	cjsModule;
